import {
    Arrow,
    ButtonContainer,
    Card,
    Content,
    StyledButton,
    Title
} from "@/components/organism/OnboardingTip/OnboardingTip.styles";

type OnboardingButton = {
  text: string;
  iconName?: string;
  onClick: () => void;
};

type OnboardingTipProps = {
  show: boolean;
  title: string;
  content: string;
  previousButton?: OnboardingButton;
  nextButton?: OnboardingButton;
  stepIndex: number;
};

const OnboardingTip = ({ show, title, content, previousButton, nextButton, stepIndex }: OnboardingTipProps) => {
  if (!show) {
    return null;
  }

  const buttonCount = (previousButton ? 1 : 0) + (nextButton ? 1 : 0);

  return (
    <Card stepIndex={stepIndex}>
      <Arrow />
      <Title>{title}</Title>
      <Content>{content}</Content>
      <ButtonContainer buttonCount={buttonCount}>
        {previousButton && (
          <StyledButton type="button" className="btn btn-secondary hover border-none" onClick={previousButton.onClick}>
            <span className={`rioglyph ${previousButton.iconName}`} aria-hidden="true" />
            {previousButton.text}
          </StyledButton>
        )}
        {nextButton && (
          <StyledButton type="button" className="btn btn-secondary border-color-white" onClick={nextButton.onClick}>
            {nextButton.text}
            {nextButton.iconName ? <span className={`rioglyph ${nextButton.iconName}`} aria-hidden="true" /> : null}
          </StyledButton>
        )}
      </ButtonContainer>
    </Card>
  );
};

export default OnboardingTip;
